// FirebaseStatus.jsx — Indicateur de connexion Firebase (visible admin seulement)
import React, { useState, useEffect } from 'react';
import { useApp } from '../../context/AppContext';

export default function FirebaseStatus() {
  const { currentUser, fbReady } = useApp();
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const on  = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online',  on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  // Visible uniquement pour l'admin
  if (currentUser?.role !== 'admin') return null;

  const status = !online ? 'offline' : fbReady ? 'synced' : 'loading';
  const config = {
    offline: { color: '#FF4060', icon: '⚡', label: 'Hors-ligne' },
    loading: { color: '#D4A017', icon: '↻',  label: 'Synchro...' },
    synced:  { color: '#00CC88', icon: '☁️', label: 'Firebase ✓' },
  }[status];

  return (
    <div style={{
      position: 'fixed', bottom: '80px', left: '16px', zIndex: 8000,
      background: 'rgba(8,13,26,0.92)', border: `1px solid ${config.color}`,
      borderRadius: '20px', padding: '6px 12px',
      display: 'flex', alignItems: 'center', gap: '6px',
      fontSize: '12px', color: config.color, fontWeight: 700,
      backdropFilter: 'blur(10px)',
      animation: status === 'loading' ? 'spin 1s linear infinite' : 'none',
      boxShadow: `0 0 10px ${config.color}33`,
    }}>
      <span style={{
        display: 'inline-block',
        animation: status === 'loading' ? 'fbSpin 1s linear infinite' : 'none',
      }}>
        {config.icon}
      </span>
      {config.label}
      <style>{`
        @keyframes fbSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
